module.exports = __webpack_public_path__ + "static/media/AC-Fish_yingyang.14959bb6.png";